import { CbhFeatureFlag, useCbhFlag } from "@src/appV2/FeatureFlags";
import {
  convertNumberToWord,
  isNumberConvertableToWord,
} from "@src/appV2/lib/utils/convertNumberToWord";
import { DEFAULT_ENABLED_BASKET_SIZE_LIMIT_CONFIGURATION } from "@src/appV2/redesign/Tiers/utils/constants";

export function useTiersBasketSize() {
  const basketSizeLimitConfiguration = useCbhFlag(CbhFeatureFlag.BASKET_SIZE_LIMIT_CONFIGURATION, {
    defaultValue: DEFAULT_ENABLED_BASKET_SIZE_LIMIT_CONFIGURATION,
  });
  const {
    limited: {
      leadTimeThresholdInHrs: defaultLeadTimeThresholdInHrs,
      basketSize: defaultBasketSize,
    },
  } = DEFAULT_ENABLED_BASKET_SIZE_LIMIT_CONFIGURATION;

  const leadTimeThresholdInHrs = basketSizeLimitConfiguration.limited.enabled
    ? basketSizeLimitConfiguration.limited.leadTimeThresholdInHrs
    : defaultLeadTimeThresholdInHrs;
  const basketSize = basketSizeLimitConfiguration.limited.enabled
    ? basketSizeLimitConfiguration.limited.basketSize
    : defaultBasketSize;
  const basketSizeWord = isNumberConvertableToWord(basketSize)
    ? convertNumberToWord(basketSize)
    : basketSize.toString();

  return {
    leadTimeThresholdInHrs,
    basketSize,
    basketSizeWord,
  };
}
